import { FormControl as oFormControl, Select as oSelect } from '@material-ui/core';
import styled from 'styled-components';

export const FormControl = styled(oFormControl)`
  && {
    margin: 0;
  }
`;

export const FormItem = styled.div`
  display: flex;
  flex-direction: row;
`;

export const FormItemContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const Select = styled(oSelect)`
  && {
    font-size: 14px;
  }
`;
